import { configPrice } from "../modules/v2/Price";

const formatPrice = (
  price: number,
  prefixPositive = "",
  currency: "IDR" | "MYR" = "IDR",
  currencySymbol?: string
) => {
  const symbol = currencySymbol ?? configPrice[currency]?.prefix;
  if (!price) return `${symbol}0`;

  const result = Math.abs(price).toLocaleString(
    configPrice[currency]?.locales ?? "id"
  );
  return `${price < 0 ? "- " : prefixPositive}${symbol}${result}`;
};
export default formatPrice;

